import { ITypedReduxAction } from '../../types/redux';

export enum EResultsActionType {
  SetSubdomain = 'results/setSubdomain',
}

export type TSetSubdomain = ITypedReduxAction<EResultsActionType.SetSubdomain, string>;

export type TResultsActions = TSetSubdomain;
